<template>
  <div>
    <Input search enter-button="查询" placeholder="请输入文件名关键字..." />
    <br />
    <Table :data="tableData1" :columns="tableColumns1" size="small" stripe></Table>
    <Row>
      <br />
      <Col span="2">
      </Col>
    </Row>
    <br>
    <Row>
      <Col span="24">
      <Page :total="20" :current="1" @on-change="changePage"></Page>
      </Col>
    </Row>
  </div>
</template>
<script>
import identicalData from '../../assets/json/identicalData.json'
import expandRow from './content_main_list_expandtable.vue'
export default {
  name: "CloudList",
  data() {
    return {
      formItem: {
        industryselected: [],
      },
      // tagList: SelectData.industry,
      tableData1: this.mockTableData1(), //tabledata.tabrows,
      tableColumns1: this.mockTableHeader(),
      showHeaders: [],
      // showfilename:false,
      sliders: this.getSliders(),
    }
  },
  inject: ['CreatePage', 'getSliders'],
  methods: {
    mockTableData1() {
      let da = [];
      // console.log(tabledata.tabrows);
      let items = identicalData.tabrows
      //console.log(items);
      //var items=JSON.parse(tabledata.tabrows);
      //var x=h('Tag', {props: {type: 'dot',color:red}}, "txt");

      for (var i = 0; i < items.length; i++) {
        let expand = true;
        if (items[i].filecount >= 3) {
          expand = false; //启用
        }
        da.push({
          fileid: items[i].fileid,
          filename: items[i].filename,
          filecount: items[i].filecount,
          _disableExpand: expand,
          children: items[i].children,
        })
      }
      //console.log(da)
      return da;
    },
    mockTableHeader(obj) {
      let da = [];
      let items = identicalData.header;
      let newHeaders = [];
      this.setHeader(obj);
      for (var i = 0; i < items.length; i++) {
        if (this.showHeaders.indexOf(items[i].key) >= 0) {
          newHeaders.push(items[i])
        }
      }
      // console.log(newHeaders)
      items = newHeaders;
      for (var i = 0; i < items.length; i++) {
        if (items[i].key == "filename") {
          da.push({
            title: items[i].title,
            key: items[i].key,
            width: items[i].width,
            align: items[i].align,
            render: (h, params) => {
              const row = params.row;
              const keywords=["国务院","经贸委","部","01","a"]
              var tt = row.filename;
              const fileid = row.fileid;
              return h('a', {
                on: {
                  'click': () => {
                    this.add(fileid, 1);
                    // this.showfilename=true;
                  }
                },
                style: {
                  fontSize: '14px'
                },
                //匹配关键词
                // domProps: {
                //   innerHTML: this.replaceKeyWord(tt,keywords)
                // },
              }, tt);
            }
          })

        } else {
          da.push({
            title: items[i].title,
            key: items[i].key,
            width: items[i].width,
            align: items[i].align,
          })
        }

      }
      da.push({
        type: 'expand',
        align: "left",
        width: 50,
        className: "expandclass",
        render: (h, params) => {
          // const row = params.row;
          return h(expandRow, {
            style: {
              // height: '48px',
              // width: '141px',
              //color:'red',
            },
            props: {
              row: params.row
            }
          })
        }
      })

      return da;
    },
    setHeader(arrayObj) {
      if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
        this.showHeaders = ['fileid', 'filename']
      } else {
        this.showHeaders = arrayObj
      }

    },

    changePage() {
      this.tableData1 = this.mockTableData1();
    },
    add(fid, orderid) {
      this.CreatePage(fid, orderid);
    },
    reloadHeaderData(obj) {
      this.tableColumns1 = this.mockTableHeader(obj);
    },
    // rowClassName(row, index) {
    //   if (index === 1) {
    //     return 'demo-table-info-row';
    //   } else if (index === 3) {
    //     return 'demo-table-error-row';
    //   }
    //   return 'demo-table-info-row';
    // },
    //用户匹配关键词，需启用
    replaceKeyWord(text,keys){
      let rawText=text;
      for(let i=0;i<keys.length;i++){
        rawText=rawText.replace(keys[i],"<font color=red>"+keys[i]+"</font>")
      }
      //console.log(rawText)
      return rawText; 
    }
  },
  watch: {

    sliders: function() {
      if (this.sliders.length == 0) {
        this.reloadHeaderData([]);
      } else if (this.sliders.length > 0) {
        this.reloadHeaderData(['filename']);
      }
    },
  },
  components: { expandRow },
}

</script>
<style>
.expandclass {
  background-color: white;
}

.ivu-table-expanded-cell {
  background-color: #fff !important;
}


.ivu-table .demo-table-info-row td {
  background-color: #F7F7F7;
  color: #fff;
}

.ivu-table .demo-table-error-row td {
  background-color: #ff6600;
  color: #fff;
}

td.ivu-table-expanded-cell {
  padding: 10px 10px;
  background: #f8f8f9;
}

</style>
